import logo from '/logo.svg';

import { useLocation, useNavigate } from 'react-router-dom';
import { PhoneInput } from 'react-international-phone';
import { useState } from 'react';
import { PhoneNumberUtil } from 'google-libphonenumber';

import Button from 'components/Button';

import './index.css';
import { useTranslation } from 'react-i18next';

const phoneUtil = PhoneNumberUtil.getInstance();

const isPhoneValid = (phone: string) => {
  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
  } catch (error) {
    return false;
  }
};

const SetPhoneNumber = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [phone, setPhone] = useState('');

  const isValid = isPhoneValid(phone);

  const onChangePhone = (phone: string) => {
    setPhone(phone);
  };

  const onSubmit = () => {
    navigate(`/auth/confirm-phone-number?phoneNumber=${phone}&prev=${pathname}`);
  };

  return (
    <div className="flex flex-col w-full items-center justify-center max-h-screen">
      <div className="flex flex-col border py-14 px-10 rounded-2xl border-[#CBCBCB] bg-[#fff] w-[480px] md:w-80">
        <div className="justify-center items-center flex">
          <img src={logo} alt="logo" />
        </div>
        <div className="text-3xl font-bold mt-10 mb-3 justify-center items-center flex md:text-xl md:mt-6">
          {t('welcomeToEvs')}
        </div>
        <span className="text-base text-center text-[#757575] justify-center items-center flex md:text-sm">
          Please enter your phone number to receive the code for 2FA via SMS
          <br />
        </span>
        <div className="mt-8 relative">
          <PhoneInput value={phone} onChange={onChangePhone}/>
          {!isValid && <div className='absolute text-sm left-1 bottom-[-1.25rem] text-red-800'>Phone is not valid</div>}
        </div>
        <div className="mt-8 flex justify-center">
          <Button onClick={onSubmit} size="sm" disabled={!isValid}>
            Confirm
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SetPhoneNumber;
